import { render, staticRenderFns } from "./CollectionFilterCategory.vue?vue&type=template&id=8635b9ce&lang=pug&"
import script from "./CollectionFilterCategory.vue?vue&type=script&lang=js&"
export * from "./CollectionFilterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8635b9ce')) {
      api.createRecord('8635b9ce', component.options)
    } else {
      api.reload('8635b9ce', component.options)
    }
    module.hot.accept("./CollectionFilterCategory.vue?vue&type=template&id=8635b9ce&lang=pug&", function () {
      api.rerender('8635b9ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionFilterCategory.vue"
export default component.exports